import axios from 'axios';
import config from '../config';

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});

axiosInstance.defaults.headers.common['HOMECOOK-SECRET-KEY'] = process.env.REACT_APP_SECRET_KEY || '';
axiosInstance.defaults.headers.common['HOMECOOK-API-KEY'] = process.env.REACT_APP_API_KEY || '';

export const loadContactSource = async (communityId: string) => {
  const response = await axiosInstance.get(`/community/${communityId}/contact-builder/source`);
  return response.data;
};

export const handoffContactList = async (communityId: string, briefId: string, resourceId: string) => {
  const response = await axiosInstance.post(`/community/${communityId}/contact-builder/briefs/${briefId}/handoff`, {
    resource_id: resourceId,
    approved: false,
  });
  return response.data;
};

export const createContactProject = async (communityId: string, resourceId: string, name: string) => {
  const response = await axiosInstance.post(`/community/${communityId}/contact-builder/projects`, {
    resource_id: resourceId,
    name,
    owner_uid: 'staff',
  });
  return response.data;
};

export const createContactBrief = async (communityId: string, projectId: string, description: string) => {
  const response = await axiosInstance.post(`/community/${communityId}/contact-builder/projects/${projectId}/briefs`, {
    business_description: description,
  });
  return response.data;
};

export const confirmContactBrief = async (communityId: string, briefId: string, answers: Record<string, unknown>) => {
  const response = await axiosInstance.post(`/community/${communityId}/contact-builder/briefs/${briefId}/confirm`, {
    answers,
    consent: {
      granted: true,
      granted_at: new Date().toISOString(),
      notice_version: '2026-10-05',
    },
  });
  return response.data;
};

export const startContactRun = async (communityId: string, briefId: string, idempotencyKey: string) => {
  const response = await axiosInstance.post(`/community/${communityId}/contact-builder/briefs/${briefId}/runs`, {
    idempotency_key: idempotencyKey,
    seeds: [],
  });
  return response.data;
};

export const listContactProjects = async (communityId: string) => {
  const response = await axiosInstance.get(`/community/${communityId}/contact-builder/projects`);
  return response.data?.items || [];
};

/** One summary per member list on this expert: counts, latest brief, and handoff status. */
export const listContactProjectSummaries = async (communityId: string, resourceId: string) => {
  const response = await axiosInstance.get(`/community/${communityId}/contact-builder/projects`, {
    params: { resource_id: resourceId },
  });
  return response.data?.items || [];
};

export const listContactRecords = async (communityId: string, projectId: string) => {
  const response = await axiosInstance.get(`/community/${communityId}/contact-builder/contacts`, {
    params: { project_id: projectId },
  });
  return response.data?.items || [];
};

export const exportContacts = async (communityId: string, briefId: string) => {
  const response = await axiosInstance.post(`/community/${communityId}/contact-builder/exports`, { brief_id: briefId });
  return response.data;
};

export const previewDscvry = async (communityId: string, briefId: string) => {
  const response = await axiosInstance.post(`/community/${communityId}/contact-builder/connectors/dscvry/preview`, {
    brief_id: briefId,
  });
  return response.data;
};

export const connectDscvryIntegration = async (
  communityId: string,
  resourceId: string,
  signupUrl: string,
  webhookUrl: string,
) => {
  const response = await axiosInstance.post(`/community/${communityId}/contact-builder/integrations/dscvry`, {
    resource_id: resourceId,
    signup_url: signupUrl,
    webhook_url: webhookUrl,
  });
  return response.data;
};
